import { combineReducers } from 'redux';

import { reducer as sso } from './ssoModule';
import { reducer as usages } from './usagesModule';

export default combineReducers({
	usages,
	sso,
});
